import {RepositoryFactory} from '@/repository/RepositoryFactory';

const TasksRepository = RepositoryFactory.get('tasks');

export default {
  state: {
    tasks: [],
    side_task_bar_data: { active: false, id: null },
  },
  mutations: {
    SET_TASKS: (state, data) => {
      state.tasks = data
    },
    DELETE_TASK: (state, id) => {
      state.tasks = state.tasks.filter((x) => x.id !== id)
    },
    TOGGLE_SIDE_TASK_BAR: (state, payload) => {
      state.side_task_bar_data = payload
    },
  },
  getters: {
    tasks: state => state.tasks,
    side_task_bar_data: state => state.side_task_bar_data,
  },
  actions: {
    async fetchTasks({commit}) {
      const { data } = (await TasksRepository.getTasks()).data
      commit('SET_TASKS', data );
    },
    async fetchTasksByYou({commit}) {
      const {data} = (await  TasksRepository.getTasksByYou()).data
      commit('SET_TASKS', data );
    },
    async createTask({commit, dispatch}, payload) {
      await TasksRepository.createTask(payload)
      dispatch('fetchTasks')
    },
    async deleteTask({commit, dispatch}, id) {
      commit('DELETE_TASK', id);

      await TasksRepository.deleteTask(id);
      dispatch('fetchTasks');
    },
    async updateTask({commit, dispatch}, {id, payload}) {
      await TasksRepository.updateTask(id, payload)
      dispatch('fetchTasks')
    },
    async changeTaskStatus({commit, dispatch}, {id, status}) {
      await TasksRepository.statusChange(id, status)
      dispatch('fetchTasks')
    },
  }
}
